import styled, { css } from 'styled-components'
import { CouponFieldInterface } from 'common/types/entities/CouponInterface'
import {
  backgroundColorCss,
  borderCss,
  colorCss,
  fontSizeCss,
  mobileBackgroundColorCss,
  mobileBorderCss,
  mobileColorCss,
  mobileFontSizeCss,
} from 'common/utils/styleUtilsNew'

type CouponFieldUip = Omit<CouponFieldInterface, 'placeholder'>

const defaultMobileCss = css`
  width: 100%;
  max-width: 100%;
  margin-bottom: 10px;
  margin-right: 0;
`

const CouponFieldUi = styled.input<CouponFieldUip>`
  max-width: 300px;
  margin-right: 5px;
  padding: 5px;
  outline: none;
  ::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    text-transform: capitalize;
    font-style: italic;
  }
  ::-moz-placeholder {
    /* Firefox 19+ */
    text-transform: capitalize;
  }
  :-ms-input-placeholder {
    /* IE 10+ */
    text-transform: capitalize;
  }

  ${fontSizeCss}
  ${colorCss}
  ${backgroundColorCss}
  ${borderCss}
  
  ${p => p.theme.phone} {
    ${defaultMobileCss};
    ${mobileFontSizeCss}
    ${mobileColorCss}
    ${mobileBackgroundColorCss}
    ${mobileBorderCss}
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${defaultMobileCss};
      ${mobileFontSizeCss}
      ${mobileColorCss}
      ${mobileBackgroundColorCss}
      ${mobileBorderCss}
    `}
`

export default CouponFieldUi
